import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME_REFERENCE_BOOK } from '@/features/constants';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { ViolationMeasure } from './types';

export const violationMeasuresApi = createApi({
  reducerPath: 'violationMeasuresApi',
  baseQuery: axiosBaseQuery({
    baseUrl: Config.VITE_API_URL + '/violation-measures',
  }),
  keepUnusedDataFor: CACHE_EXPIRATION_TIME_REFERENCE_BOOK,
  endpoints: builder => ({
    getViolationMeasures: builder.query<ViolationMeasure[], void>({
      query: () => ({
        url: '/',
      }),
    }),
  }),
});

export const { useGetViolationMeasuresQuery } = violationMeasuresApi;
